// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28hlb","footer":"styles_footer__j1kdf"};